import { render, staticRenderFns } from "./CmsDynamicPage.vue?vue&type=template&id=316b4d6c&"
import script from "./CmsDynamicPage.vue?vue&type=script&lang=js&"
export * from "./CmsDynamicPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports